<template>
  <div class="card mb-4">
    <div class="card-header bg-info text-light">
      My Organization
    </div>
    <div class="card-body">
      <form @submit.prevent="submit" class="needs-validation">
        <fieldset class="form-group">
          <label for="lname">Organization Name</label>
          <input v-model="org.name" type="text" :class="['form-control', { 'is-invalid':validationErrors.name }]" id="name" name="name">
          <div class="invalid-feedback" v-if="validationErrors.name" v-text="validationErrors.name"></div>
        </fieldset>
        <fieldset class="form-group">
          <label for="lname">Website</label>
          <input v-model="org.website" type="text" :class="['form-control', { 'is-invalid':validationErrors.website }]" id="website" name="org_website">
          <div class="invalid-feedback" v-if="validationErrors.website" v-text="validationErrors.website"></div>
        </fieldset>
        <fieldset class="form-group">
          <label for="lname">Type</label>
          <select v-model="org.type" :class="['form-control', { 'is-invalid':validationErrors.type }]" id="type" name="type">
            <option value="">Please select type...</option>
            <option value="CU">Credit Union</option>
            <option value="BANK">Bank</option>
            <option value="CB">Community Bank</option>
            <option value="OTHR">Other</option>
          </select>
          <div class="invalid-feedback" v-if="validationErrors.type" v-text="validationErrors.type"></div>
        </fieldset>
        <div v-if="formStatus.success === true" class="alert alert-success alert-dismissible" role="alert" style="margin-top:20px">
          <p>You organization has been saved.</p>
          <button @click="clearFormStatus()" type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div v-else-if="formStatus.error === true" class="alert alert-danger alert-dismissible" role="alert" style="margin-top:20px">
          <h4 class="alert-heading" v-text="formStatus.statusHeading"></h4>
          <p v-text="formStatus.statusBody"></p>
          <button @click="clearFormStatus()" type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <button v-else type="submit" class="btn btn-primary">Save</button>
      </form>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import Org from '@/structs/Org'

export default {
  name: 'OrgProfileForm',
  computed: mapGetters('auth', ['currentOrg']),
  data () {
    return {
      org: new Org(),
      validationErrors: {
        name: null,
        website: null,
        type: null
      },
      formStatus: {
        success: null,
        error: null,
        statusHeading: null,
        statusBody: null
      }
    }
  },
  created () {
    this.setOrg()
  },
  methods: {
    ...mapActions('org', ['update']),
    submit () {
      if (this.validateForm()) {
        this.update(this.org)
          .then(response => { this.setOrg(); this.markSuccess() })
          .catch(response => { this.markError(response.message) })
      }
    },
    setOrg () {
      this.org = Object.assign(new Org(), this.currentOrg)
    },
    clearFormStatus () {
      this.formStatus.success = null
      this.formStatus.error = null
      this.statusHeading = null
      this.statusBody = null
    },
    markSuccess () {
      this.clearFormStatus()

      this.formStatus.success = true
    },
    markError (message) {
      console.log(message)
      this.clearFormStatus()

      this.formStatus.statusHeading = 'Error'
      this.formStatus.statusBody = (message || 'Unable to save organization.')
      this.formStatus.error = true
    },
    clearValidationErrors () {
      for (var k in this.validationErrors) {
        this.validationErrors[k] = null
      }
    },
    validateForm () {
      this.clearValidationErrors()

      if ((this.org.name || '') === '') {
        this.validationErrors.fname = 'Empty or invalid organization name'
        return false
      }

      if ((this.org.website || '') === '') {
        this.validationErrors.website = 'Empty or invalid website'
        return false
      }

      if ((this.org.type || '') === '') {
        this.validationErrors.type = 'Empty or invalid organization type'
        return false
      }

      return true
    }
  }
}

</script>
